import { create } from '@/store'
import { devtools } from 'zustand/middleware'

const useAppStatusStore = create(
  devtools(
    (set) => ({
      isVisible: true,
      isInternetConnected: true,
      setIsVisible: (status) => set({ isVisible: status }),
      setIsInternetConnected: (status) => set({ isInternetConnected: status }),
    }),
    { name: 'app-status-store' },
  ),
)

export default useAppStatusStore
